(() => {
  const STRIKE_CLASS = 'yk-smart-cart-strike-price';
  const BREAKDOWN_CLASS = 'yk-smart-cart-discount-breakdown';
  const PROMO_2_PLUS_1_TITLE = window.ykCartPromoBadge?.discountTitle || null;

  const toNumber = (value) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
  };

  const parseMoneyStringToCents = (value) => {
    if (typeof value !== 'string') return null;

    const normalized = value.replace(',', '.').trim();
    if (!normalized) return null;

    const parsed = Number(normalized);
    if (!Number.isFinite(parsed) || parsed <= 0) return null;

    return Math.round(parsed * 100);
  };

  const parseAnyMoneyToCents = (value) => {
    if (typeof value === 'string') {
      return parseMoneyStringToCents(value);
    }

    if (typeof value === 'number' && Number.isFinite(value) && value > 0) {
      return value > 1000 ? Math.round(value) : Math.round(value * 100);
    }

    return null;
  };

  const formatMoney = (cents) => {
    const safeValue = Math.max(0, toNumber(cents));
    return (safeValue / 100).toFixed(2).replace('.', ',') + ' zł';
  };

  const getItemVariant = (item) => {
    const variants = item?.product?.variants;
    if (!Array.isArray(variants) || variants.length === 0) return null;

    const itemVariantId = toNumber(item?.variant_id);
    return variants.find((variant) => toNumber(variant?.id) === itemVariantId) || null;
  };

  const hasTwoPlusOnePromo = (item) => {
    if (!PROMO_2_PLUS_1_TITLE || !Array.isArray(item?.discounts)) return false;
    return item.discounts.some((discount) => discount?.title === PROMO_2_PLUS_1_TITLE);
  };

  const getDiscountCodeAmount = (item) => {
    if (!Array.isArray(item?.discounts)) return 0;

    return item.discounts.reduce((sum, discount) => {
      const amount = toNumber(discount?.amount);
      return sum + (amount > 0 ? amount : 0);
    }, 0);
  };

  const computePriceModel = (item) => {
    const quantity = Math.max(1, toNumber(item?.quantity));
    const finalLinePrice = toNumber(item?.final_line_price);
    const isSubscription = Boolean(item?.selling_plan_allocation);
    const sellingPlan = item?.selling_plan_allocation || null;
    const variant = getItemVariant(item);

    if (!variant || finalLinePrice <= 0) return null;

    const variantCompareAtStringCents = parseMoneyStringToCents(variant.compare_at_price);
    const variantOneTimePriceCents = parseAnyMoneyToCents(variant.price);
    const promoCodeDiscount = getDiscountCodeAmount(item);
    const itemUnitPriceCents = parseAnyMoneyToCents(item?.price);

    let referenceOneTimeUnitPrice = variantCompareAtStringCents || toNumber(sellingPlan?.compare_at_price) || 0;
    if (!referenceOneTimeUnitPrice && !isSubscription && promoCodeDiscount > 0 && itemUnitPriceCents) {
      referenceOneTimeUnitPrice = itemUnitPriceCents;
    }
    if (!referenceOneTimeUnitPrice) return null;

    const strikeUnitPrice = referenceOneTimeUnitPrice;
    const strikeLinePrice = strikeUnitPrice * quantity;
    if (strikeLinePrice <= finalLinePrice) return null;

    let compareAtDiscount = 0;
    if (
      variantCompareAtStringCents &&
      variantOneTimePriceCents &&
      variantCompareAtStringCents > variantOneTimePriceCents
    ) {
      compareAtDiscount = (variantCompareAtStringCents - variantOneTimePriceCents) * quantity;
    }

    let subscriptionDiscount = 0;
    if (isSubscription) {
      const oneTimeSubBase = variantOneTimePriceCents || toNumber(sellingPlan?.compare_at_price);
      const subUnitPrice = toNumber(sellingPlan?.price || sellingPlan?.per_delivery_price);

      if (oneTimeSubBase > 0 && subUnitPrice > 0 && oneTimeSubBase > subUnitPrice) {
        subscriptionDiscount = (oneTimeSubBase - subUnitPrice) * quantity;
      }
    }

    const totalDiscount = Math.max(strikeLinePrice - finalLinePrice, 0);
    if (totalDiscount <= 0) return null;

    return {
      strikeUnitPrice,
      strikeLinePrice,
      totalDiscount,
      compareAtDiscount: Math.max(compareAtDiscount, 0),
      subscriptionDiscount: Math.max(subscriptionDiscount, 0),
      promoCodeDiscount: Math.max(promoCodeDiscount, 0),
    };
  };

  const cleanupItemUi = (itemElement) => {
    itemElement.querySelectorAll(`.${STRIKE_CLASS}`).forEach((el) => el.remove());
    itemElement.querySelectorAll(`.${BREAKDOWN_CLASS}`).forEach((el) => el.remove());
  };

  const renderItem = (item, itemElement) => {
    cleanupItemUi(itemElement);

    if (hasTwoPlusOnePromo(item)) return;

    const priceWrapper = itemElement.querySelector('.rebuy-cart__flyout-item-price');
    const priceInner = priceWrapper?.querySelector('div') || priceWrapper;
    const saleSpan = priceInner?.querySelector('.rebuy-money.sale') || priceInner?.querySelector('.rebuy-money');

    if (!priceWrapper || !priceInner || !saleSpan) return;

    const model = computePriceModel(item);
    if (!model) return;

    const strikeEl = document.createElement('span');
    strikeEl.className = `rebuy-money ${STRIKE_CLASS}`;
    strikeEl.textContent = formatMoney(model.strikeUnitPrice);
    strikeEl.style.display = 'block';
    const breakdownEl = document.createElement('div');
    breakdownEl.className = BREAKDOWN_CLASS;
    breakdownEl.textContent = `Zniżka ${formatMoney(model.totalDiscount)} (CAP ${formatMoney(
      model.compareAtDiscount
    )}, SUB ${formatMoney(model.subscriptionDiscount)}, KOD ${formatMoney(model.promoCodeDiscount)})`;
    breakdownEl.style.marginTop = '2px';
    breakdownEl.style.fontSize = '10px';
    breakdownEl.style.lineHeight = '1.25';
    breakdownEl.style.color = '#777777';

    saleSpan.insertAdjacentElement('afterend', strikeEl);
    strikeEl.insertAdjacentElement('afterend', breakdownEl);
  };

  const renderAll = () => {
    const items = window.Rebuy?.SmartCart?.cart?.items;
    if (!Array.isArray(items) || items.length === 0) return;

    items.forEach((item) => {
      if (!item?.key) return;

      const itemElements = document.querySelectorAll(`.rebuy-cart__flyout-item[data-item-key="${item.key}"]`);
      itemElements.forEach((itemElement) => renderItem(item, itemElement));
    });
  };

  const scheduleRender = () => {
    window.requestAnimationFrame(() => {
      setTimeout(renderAll, 260);
    });
  };

  document.addEventListener('rebuy:cart.ready', scheduleRender);
  document.addEventListener('rebuy:cart.change', scheduleRender);
  document.addEventListener('rebuy:cart.enriched', scheduleRender);
  document.addEventListener('rebuy:smartcart.show', scheduleRender);
})();
